<template>
    <!-- 检测记录-查看报告 -->
    <el-dialog
        title="查看报告"
        :visible.sync="dialogVisible"
        width="1200px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        top="8vh"
        :before-close="handleClose"
        custom-class="res-pop"
    >
        <div
            v-loading="loading"
            class="check-report-container"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255,255,255,0)"
            style="padding-top: 15px"
        >
            <div class="tabs-head dfc">
                <p v-if="textCheckType" :class="{ active: showText === 0 }" @click="changeTab(0)">
                    文字检测<i v-if="textNum">{{ textNum }}</i>
                </p>
                <p v-if="imageCheckType" :class="{ active: showText === 1 }" @click="changeTab(1)">
                    图片检测<i v-if="imgNum">{{ imgNum }}</i>
                </p>
                <p class="empty">
                    <span>请注意：待上架商品修改后将直接上架，操作后请关注商品上下架状态</span>
                </p>
            </div>
            <div class="mt10 mb10 dfcjsb">
                <div style="flex: 1">
                    <span>状态：</span>
                    <el-select
                        v-model="statusValue"
                        placeholder="请选择"
                        size="small"
                        style="width: 130px"
                        @change="getList(1)"
                    >
                        <el-option
                            v-for="item in statusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                    <span v-show="textshowTips && showText === 0" class="ml10 lh15"
                        ><font style="color: #e91b00">*注意:</font
                        >当前内容是同步上一次的检测结果，如有修改请重新检测，重新检测需另外支付检测费用</span
                    >
                    <span v-show="imgshowTips && showText === 1" class="ml10 lh15"
                        ><font style="color: #e91b00">*注意:</font
                        >当前内容是同步上一次的检测结果，如有修改请重新检测，重新检测需另外支付检测费用</span
                    >
                </div>
                <div style="text-align: right">
                    <el-button
                        v-show="showText === 0 && textNum"
                        type="primary"
                        size="small"
                        @click="clearForbiddenWord('', true)"
                        >一键清除全部违禁词</el-button
                    >
                    <el-button v-show="showText === 0 && textNum" type="danger" size="small" @click="batchDel"
                        >批量删除产品</el-button
                    >
                    <div v-show="showText === 1 && imgNum" class="dfc">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="仅下载状态为“待处理”且还未删除的产品"
                            placement="top"
                        >
                            <el-button type="primary" size="small" @click="downImg">下载违规图片</el-button>
                        </el-tooltip>
                        <el-button type="danger" size="small" @click="clearWordChange(0)">一键清除违禁词图片</el-button>
                        <el-button type="danger" size="small" @click="batchDel">批量删除产品</el-button>
                    </div>
                </div>
            </div>
            <div v-show="tableData.length" class="tabs">
                <el-table :data="tableData" style="width: 100%" :header-cell-style="tableHeader" max-height="500px">
                    <el-table-column label="序号" width="90" header-align="center" scoped-slot>
                        <template #header>
                            <el-checkbox v-model="checkAll" style="margin-right: 5px" @change="checkAllList" />
                            序号
                        </template>
                        <template #default="{ $index, row }">
                            <div class="dfcjc">
                                <el-checkbox
                                    v-model="checkedRow[$index]"
                                    style="margin-right: 5px"
                                    :disabled="showText === 0 ? row.wordState !== 0 : row.imageState !== 0"
                                />
                                {{ (query.index - 1) * query.size + $index + 1 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="图片" width="80" header-align="center" align="center">
                        <template #default="{ row }">
                            <el-popover placement="right" trigger="hover">
                                <div slot="reference" fit="contain">
                                    <img
                                        v-if="row.preImage"
                                        :src="row.preImage"
                                        alt=""
                                        style="width: 50px; height: 50px"
                                    />
                                    <img
                                        v-else
                                        src="https://oss.fjdaze.com/aliProject/no_image100x100.jpg"
                                        alt=""
                                        style="width: 50px; height: 50px"
                                    />
                                </div>
                                <img
                                    v-if="row.preImage"
                                    :src="row.preImage"
                                    alt=""
                                    style="width: 240px; height: 240px"
                                />
                                <img
                                    v-else
                                    src="https://oss.fjdaze.com/aliProject/no_image100x100.jpg"
                                    alt=""
                                    style="width: 240px; height: 240px"
                                />
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品信息" header-align="center">
                        <template #default="{ row }">
                            <p class="textOver" :title="row.subject">
                                {{ row.subject }}
                            </p>
                        </template>
                    </el-table-column>
                    <!-- -----------文字检测 开始------------------------------------------------------ -->
                    <el-table-column
                        v-if="showText === 0"
                        label="标题违禁词"
                        :width="hasAttribute || hasAttribute ? '120' : '150'"
                        align="center"
                        header-align="center"
                    >
                        <template #default="{ row }">
                            <el-tooltip
                                v-if="row.subjectFw"
                                class="item"
                                effect="dark"
                                :content="row.subjectFw"
                                placement="top"
                            >
                                <p class="textOver">
                                    {{ row.subjectFw }}
                                </p>
                            </el-tooltip>

                            <p v-else class="gray">未找到违禁词</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="showText === 0 && hasAttribute"
                        label="属性违禁词"
                        width="120"
                        align="center"
                        header-align="center"
                    >
                        <template #default="{ row }">
                            <el-tooltip
                                v-if="row.attributesFw"
                                class="item"
                                effect="dark"
                                :content="row.attributesFw"
                                placement="top"
                            >
                                <p class="textOver">
                                    {{ row.attributesFw }}
                                </p>
                            </el-tooltip>
                            <p v-else class="gray">未找到违禁词</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="showText === 0 && hasSku"
                        label="SKU违禁词"
                        width="120"
                        align="center"
                        header-align="center"
                    >
                        <template #default="{ row }">
                            <el-tooltip
                                v-if="row.skuInfosFw"
                                class="item"
                                effect="dark"
                                :content="row.skuInfosFw"
                                placement="top"
                            >
                                <p class="textOver">
                                    {{ row.skuInfosFw }}
                                </p>
                            </el-tooltip>
                            <p v-else class="gray">未找到违禁词</p>
                        </template>
                    </el-table-column>
                    <!-- -----------文字检测 结束------------------------------------------------------------ -->
                    <!-- -----------图片检测 开始------------------------------------------------------ -->
                    <el-table-column
                        v-if="showText === 1"
                        label="违禁词(详情图)"
                        width="115"
                        align="center"
                        header-align="center"
                    >
                        <template #default="{ row }">
                            <p v-if="row.detailImagExistFwWord">
                                {{ row.detailImageFwIsFgnore ? '已忽略' : '是' }}
                            </p>
                            <p v-else class="gray">否</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="showText === 1"
                        label="违禁词(主图)"
                        width="110"
                        align="center"
                        header-align="center"
                    >
                        <template #default="{ row }">
                            <p v-if="row.mainImageExistFwWord">
                                {{ row.mainImageFwIsFgnore ? '已忽略' : '是' }}
                            </p>
                            <p v-else class="gray">否</p>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
            label="方正字体(详情图)"
            v-if="showText === 1"
            width="130"
            align="center"
            header-align="center"
          >
            <template v-slot="{ row }">
              <p v-if="row.FwTypefaceCheckState">
                <span v-if="row.detailImageExistFwFont">
                  {{ row.detailImageFwIsFgnore ? "已忽略" : "是" }}
                </span>
                <span class="gray" v-else>否</span>
              </p>
              <p v-else class="gray">未检测</p>
            </template>
          </el-table-column> -->
                    <!-- <el-table-column
            label="方正字体(主图)"
            v-if="showText === 1"
            width="120"
            align="center"
            header-align="center"
          >
            <template v-slot="{ row }">
              <p v-if="row.FwTypefaceCheckState">
                <span v-if="row.mainImageExistFwFont">
                  {{ row.mainImageFwIsFgnore ? "已忽略" : "是" }}
                </span>
                <span class="gray" v-else>否</span>
              </p>
              <p v-else class="gray">未检测</p>
            </template>
          </el-table-column> -->
                    <!-- -----------图片检测 结束------------------------------------------------------------------ -->
                    <el-table-column label="状态" width="80" header-align="center" align="center">
                        <template #default="{ row }">
                            <p
                                v-show="showText === 0"
                                :class="{
                                    red: row.wordState === 0 || row.wordState === 4,
                                }"
                            >
                                <!-- 文字检测 状态 -->
                                {{ statusArr[row.wordState] }}
                            </p>
                            <p
                                v-show="showText === 1"
                                :class="{
                                    red: row.imageState === 0 || row.imageState === 4,
                                }"
                            >
                                <!-- 图片检测 状态 -->
                                {{ statusArr[row.imageState] }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="showText === 0"
                        label="操作"
                        width="120"
                        header-align="center"
                        align="center"
                    >
                        <template #default="{ row }">
                            <!-- 文字检测操作 -->
                            <div :class="[row.wordState === 0 ? 'blue' : 'gray']">
                                <div class="curp" @click="clearForbiddenWord(row, false)">一键清除</div>
                                <div
                                    class="curp"
                                    @click="row.wordState === 0 ? delProduct([row.offerIdStr], false) : ''"
                                >
                                    删除产品
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-else label="操作" width="120" header-align="center" align="center">
                        <!-- 图片检测操作 -->
                        <template #default="{ row }">
                            <div :class="[row.imageState === 0 ? 'blue' : 'gray']">
                                <div class="curp" @click="imgModify(row)">修改产品</div>
                                <div
                                    class="curp"
                                    @click="row.imageState === 0 ? delProduct([row.offerIdStr], false) : ''"
                                >
                                    删除产品
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="mt10 tc">
                    <el-pagination
                        background
                        :current-page="query.index"
                        :page-size="query.size"
                        layout="pager, total, jumper"
                        :total="query.total"
                        @current-change="handleCurrentChange"
                    />
                </div>
            </div>
            <modifyWord ref="modifyWord" :offer-statu="plan.offerStatu" @modifySuccess="getList()" />
            <modifyImage ref="modifyImage" :offer-statu="plan.offerStatu" @refresh="getList()" />
            <taskProgress ref="taskProgress" />
            <failList ref="failList" @modifyFailed="modifyFailed" />
            <newTaskProgress ref="newTaskProgress" />
        </div>
    </el-dialog>
</template>
<script>
import taskProgress from './common/progress/progress.vue';
import { cloneDeep } from 'lodash';
import modifyWord from './modifyWord';
import modifyImage from './modifyImage';
import failList from './failList';
import axios from 'axios';
import dayjs from 'dayjs';
import jszip from 'jszip';
import { saveAs } from 'file-saver';
import newTaskProgress from './common/progress/newProgress';
export default {
    name: 'CheckReport',
    components: { modifyWord, modifyImage, taskProgress, failList, newTaskProgress },
    data() {
        return {
            dialogVisible: false,
            loading: false,
            plan: {},
            textNum: '', // 文字 数量
            imgNum: '', // 图片 数量
            showText: 0, // 文字 = 0, 图片 = 1
            textCheckType: false,
            imageCheckType: false,
            query: {
                index: 1,
                size: 50,
                total: 0,
            },
            statusValue: '',
            statusOptions: [],
            statusArr: ['待处理', '处理完成', '未检出', '', '已删除'],
            tableData: [],
            tableHeader: {
                background: '#ebecf1',
                color: '#4c4b4b',
                fontSize: '14px',
                fontWeight: 'normal',
            }, // 表头样式
            checkedRow: [],
            clearValue: '',
            textshowTips: false, // 文字检测 显示提示
            imgshowTips: false, // 图片检测 显示提示
            multipleSelection: [],
            checkAll: false,
            hasAttribute: false,
            hasSku: false,
        };
    },
    watch: {
        checkedRow(val) {
            const checkNum1 = val.filter((item) => {
                return item;
            });
            const checkNum2 = this.tableData.filter((item) => {
                return this.showText === 0 ? item.wordState === 0 : item.imageState === 0;
            });
            if (checkNum1.length === checkNum2.length && checkNum1.length !== 0) {
                this.checkAll = true;
            } else {
                this.checkAll = false;
            }
        },
    },
    created() {
        const arr = [{ label: '全部', value: '' }];
        for (let i = 0; i < this.statusArr.length; i++) {
            const str = this.statusArr[i];
            if (str !== '') {
                arr.push({
                    label: str,
                    value: i,
                });
            }
        }
        this.statusOptions = Object.freeze(arr);
    },
    destroyed() {
        // this.$bus.$off("openNewTaskProgress", this.openNewTaskProgress);
    },
    methods: {
        show(row) {
            // 显示弹窗
            this.dialogVisible = true;
            this.plan = cloneDeep(row);
            let hasText = false;
            let hasImage = false;
            let flag = false;
            console.log(row);
            for (var i = 0; i < row.fwCheckTypes.length; i++) {
                if (row.fwCheckTypes[i] == 0 || row.fwCheckTypes[i] == 3 || row.fwCheckTypes[i] == 4) {
                    hasText = true;
                }
                if (row.fwCheckTypes[i] == 1) {
                    hasImage = true;
                }
                if (row.fwCheckTypes[i] == 3) {
                    this.hasAttribute = true;
                }
                if (row.fwCheckTypes[i] == 4) {
                    this.hasSku = true;
                }
            }
            if (hasImage) {
                flag = false;
            }
            if (hasText) {
                flag = true;
            }
            this.showText = flag ? 0 : 1;
            this.getList();
            if (hasText && !hasImage) {
                this.checkRule(false, hasText, hasImage);
            } else if (!hasText) {
                this.checkRule(true, hasText, hasImage);
            } else {
                this.textCheckType = hasText;
                this.imageCheckType = hasImage;
            }
        },
        checkRule(isCheckText, hasText, hasImage) {
            // 用于是否展示文字检测或图片检测
            let params;
            if (isCheckText) {
                params = {
                    planNo: this.plan.planNo,
                    PageIndex: 1,
                    PageSize: 10,
                    Type: 0,
                };
            } else {
                params = {
                    planNo: this.plan.planNo,
                    PageIndex: 1,
                    PageSize: 10,
                    Type: 1,
                };
            }
            this.$ajax.post('api/tiktok/ForbiddenWordRecord/Search', params).then((res) => {
                const data = res.result.list;
                if (data.length) {
                    if (isCheckText) {
                        this.textshowTips = true;
                        this.textCheckType = true;
                        this.imageCheckType = hasImage;
                    } else {
                        this.imgshowTips = true;
                        this.imageCheckType = true;
                        this.textCheckType = hasText;
                    }
                } else {
                    this.textCheckType = hasText;
                    this.imageCheckType = hasImage;
                }
            });
        },
        resetData() {
            // 重置数据
            this.textNum = '';
            this.imgNum = '';
            this.showText = 0;
            this.textshowTips = false;
            this.imgshowTips = false;
            this.query = {
                index: 1,
                size: 50,
                total: 0,
            };
            this.hasAttribute = false;
            this.hasSku = false;
            this.statusValue = '';
            this.textCheckType = false;
            this.imageCheckType = false;
            this.tableData = [];
        },
        gainCategory(data) {
            this.tableData = data;
            // // 获取类目信息
            // const len = data.length;
            // const arr = [];
            // for (let i = 0; i < len; i++) {
            //     arr.push(data[i].PostCategryId);
            // }
            // if (arr.length === 0) {
            //     return;
            // }
            // this.$ajax
            //     .post('aliUtils/api/category/searchbyid', {
            //         categoryIds: arr,
            //     })
            //     .then((res) => {
            //         for (let i = 0; i < len; i++) {
            //             for (let j = 0, len1 = res.Data.length; j < len1; j++) {
            //                 if (data[i].PostCategryId == res.Data[j].CategoryId) {
            //                     data[i].CategoryIdName = res.Data[j].CategoryLevelName;
            //                 }
            //             }
            //         }
            //         this.tableData = data;
            //     });
        },
        getList(index, ischangePage = false) {
            // 请求列表
            if (index) {
                this.query.index = index;
            }
            const Type = this.showText;
            this.loading = true;
            if (!ischangePage) {
                this.clearingNum();
            }
            this.$ajax
                .post('api/tiktok/ForbiddenWordRecord/Search', {
                    PageIndex: this.query.index,
                    PageSize: this.query.size,
                    planNo: this.plan.planNo,
                    Type,
                    wordState:
                        Type === 0 && (this.statusValue || this.statusValue === 0) ? this.statusValue : undefined,
                    imageState:
                        Type === 1 && (this.statusValue || this.statusValue === 0) ? this.statusValue : undefined,
                })
                .then((res) => {
                    this.loading = false;
                    if (!res.result.totalCount) {
                        this.query.index = 1;
                        this.query.total = 0;
                        this.checkedRow = [];
                        this.$message.warning('该状态下无产品');
                        this.tableData = [];
                        return;
                    }
                    const len = res.result.list.length;
                    if (len) {
                        for (let i = 0; i < len; i++) {
                            const item = res.result.list[i];
                            if (!item.mainImageFw) {
                                item.mainImageFw = '[]';
                            }
                            if (!item.detailImageFw) {
                                item.detailImageFw = '[]';
                            }
                            item.mainImageFw = JSON.parse(item.mainImageFw);
                            item.detailImageFw = JSON.parse(item.detailImageFw);
                        }
                        this.imageCheckType = true;
                        this.checkedRow = new Array(len).fill(false); // 图片检测复选框
                        this.query.total = res.result.totalCount;
                        this.gainCategory(res.result.list);
                        this.checkAll = false;
                    }
                });
        },
        clearingNum() {
            // 获取数量
            this.$ajax
                .post('api/tiktok/ForbiddenWordPlan/GetFwRecordUnclearCount?planNo=' + this.plan.planNo)
                .then((res) => {
                    if (res.code === 200) {
                        this.textNum = res.result.textFwUnClearCount >= 100 ? '99+' : res.result.textFwUnClearCount;
                        this.imgNum = res.result.imageFwUnClearCount >= 100 ? '99+' : res.result.imageFwUnClearCount;
                    }
                });
        },
        changeTab(index) {
            // 标签栏切换
            if (index === this.showText) {
                return;
            }
            this.tableData = [];
            this.showText = index;
            this.statusValue = '';
            this.getList(1);
        },
        handleCurrentChange(index) {
            // 翻页
            this.query.index = index;
            this.getList(null, true);
        },
        clearWordChange(index) {
            // index:   1=>一键清除违禁词图片  2=>一键清除方正字体图片  0=>一键清除违禁词/方正图片
            let flag = false;
            const len = this.tableData.length;
            let i = 0;
            let tip = '';
            const arr = ['一键清除违禁词', '一键清除违禁词图片', '一键清除方正字体图片'];
            // let arr = ["一键清除违禁词/方正图片", "一键清除违禁词图片", "一键清除方正字体图片"];
            if (index === 1) {
                // 一键清除违禁词图片
                tip = '检测结果中没有带违禁词的图片';
                for (; i < len; i++) {
                    if (this.tableData[i].detailImagExistFwWord || this.tableData[i].mainImageExistFwWord) {
                        flag = true;
                        break;
                    }
                }
            } else if (index == 2) {
                // 一键清除方正字体图片
                tip = '检测结果中没有带方正字体的图片';
                for (; i < len; i++) {
                    if (this.tableData[i].detailImageExistFwFont || this.tableData[i].mainImageExistFwFont) {
                        flag = true;
                        break;
                    }
                }
            } else {
                // 一键清除违禁词/方正图片
                // tip = "检测结果中没有带违禁词和方正字体的图片";
                for (; i < len; i++) {
                    if (
                        this.tableData[i].detailImageExistFwFont ||
                        this.tableData[i].mainImageExistFwFont ||
                        this.tableData[i].detailImagExistFwWord ||
                        this.tableData[i].mainImageExistFwWord
                    ) {
                        flag = true;
                        break;
                    }
                }
            }
            if (flag) {
                this.$confirm('清除后有可能导致图文详情中格式变化，且不能恢复，是否确认清除？', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                    .then(() => {
                        this.clearImage(index, arr[index]);
                    })
                    .catch(() => {});
            } else {
                if (!tip) {
                    return;
                }
                this.$message.warning(tip);
            }
        },
        clearImage() {
            // 清楚违禁词图片
            const data = {
                planNo: this.plan.planNo + '',
                FwClearType: 1,
                Action: 0,
            };
            this.$bus.$emit('openNewTaskProgress', {
                url: '/api/tiktok/ForbiddenWordPlan/ClearOfferForbiddenWord',
                taskName: '正在执行中',
                data,
                btns: [
                    {
                        name: '取 消',
                        type: '',
                        autoClose: false, // 点击按钮的时候 是否自动关闭进度条,yo
                        callback: this.cancelTask,
                    },
                    {
                        name: '后台运行',
                        type: 'primary',
                        autoClose: true, // 点击按钮的时候 是否自动关闭进度条
                        callback: () => {},
                    },
                ],
                callBack: (res) => {
                    if (res.Data.length == 0) {
                        this.$message.success('删除成功');
                        this.getList();
                    } else {
                        this.delFail(res, false);
                    }
                },
            });
            // this.$refs.taskProgress.show({
            //   url: "app/to/clearfw",
            //   data,
            //   callBack: (res) => {
            //     if (!res.Success) {
            //       this.$message.warning("删除失败");
            //       return;
            //     }
            //     if (res.SuccessCount == res.TotalCount && res.Data.length == 0) {
            //       this.$message.success("删除成功");
            //       this.getList();
            //     } else {
            //       this.delFail(res, false);
            //     }
            //   },
            // });
        },
        batchDel() {
            const ids = this.tableData
                .filter((v, i) => this.checkedRow[i]) // 选中的项且ImageState === 0
                .map((o) => o.offerIdStr); // 符合条件的产品的OfferId
            if (ids.length === 0) {
                this.$message.warning('请先选择商品');
                return;
            }
            this.delProduct(ids, true);
        },
        // 删除商品
        delProduct(ids, isBatch) {
            // if (ids.length === 0) {
            //     batchDel;
            //     return;
            // }
            this.$confirm(isBatch ? '确认删除选中的' + ids.length + '个产品吗？' : '确认删除该产品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    const data = {
                        selectProductIds: ids.join(','),
                        FwClearType: this.showText,
                        Action: 1,
                        planNo: this.plan.planNo,
                    };

                    this.$bus.$emit('openNewTaskProgress', {
                        url: '/api/tiktok/ForbiddenWordPlan/ClearOfferForbiddenWord',
                        taskName: '正在执行中',
                        data,
                        showCancelBtn: true,
                        showRunInBgBtn: true,

                        callBack: (res) => {
                            if (res.Data.length == 0) {
                                this.$message.success('删除成功');
                                this.getList();
                            } else {
                                this.delFail(res, true, true);
                            }
                        },
                    });
                })
                .catch(() => {});
        },
        textModify(row) {
            // 手动修改
            if (row.wordState !== 0) {
                return;
            }
            if (this.plan.offerStatu === 13) {
                // 草稿箱的
                // 请求接口 app/draftbox/offersget
            } else {
                this.loading = true;
                const data = {
                    ProductIds: [row.offerIdStr],
                    StatusList: ['published', 'expired'],
                };
                this.$ajax.post('app/offer/searchv2', data).then((res) => {
                    this.loading = false;
                    if (res.Success && res.Data.length > 0) {
                        row.fwCheckTypes = this.plan.fwCheckTypes;
                        row.hasAttribute = this.hasAttribute;
                        row.hasSku = this.hasSku;
                        this.$refs.modifyWord.show(row);
                    } else {
                        this.$message.warning('该产品已被删除，不支持修改');
                    }
                });
            }
        },
        imgModify(row) {
            // 图片检测 修改按钮
            if (row.imageState !== 0) {
                return;
            }
            const params = {
                productIdStr: row.offerIdStr + '',
                pageIndex: 1,
                pageSize: 10,
            };
            this.loading = true;
            this.$ajax.post('api/tiktok/Product/SearchListV2', params).then((res) => {
                this.loading = false;
                if (res.code === 200 && res.result.list.length !== 0) {
                    this.$refs.modifyImage.show(row, res.result.list[0]);
                } else {
                    this.$message.warning('该产品已被删除，不支持修改');
                }
            });
        },
        downImg() {
            // 图片检测 下载违规图片
            if (this.checkedRow.length) {
                const offerItem = this.tableData.filter((v, i) => this.checkedRow[i] && v.imageState === 0);
                if (offerItem.length) {
                    this.loading = true;
                    this.$ajax
                        .post('api/tiktok/Product/SearchListV2', {
                            selectProductIds: offerItem
                                .map((item) => {
                                    return item.offerIdStr;
                                })
                                .join(','),
                            pageIndex: 1,
                            pageSize: 100,
                        })
                        .then((res) => {
                            if (res.code === 200 && res.result.list.length) {
                                // 有产品
                                const delId = res.result.list.map((v) => v.productIdStr);
                                const len = offerItem.length;
                                if (len) {
                                    const sum = offerItem.reduce((sum, tot) => {
                                        if (typeof sum[tot.subject] === 'object') {
                                            sum[tot.subject].count++;
                                            sum[tot.subject].count2++;
                                        } else {
                                            sum[tot.subject] = {
                                                count: 0,
                                                count2: 0,
                                            };
                                        }
                                        return sum;
                                    }, {});
                                    const imageArr = [];
                                    let a = 0;
                                    for (let i = 0; i < len; i++) {
                                        let arr = [];
                                        const item = offerItem[i];
                                        if (item.mainImageFw.length) {
                                            arr = item.mainImageFw;
                                        }
                                        if (item.detailImageFw.length) {
                                            arr = arr.concat(item.detailImageFw);
                                        }
                                        const imgArr = arr.filter((v) => !v.FwIgnore);
                                        let subject;
                                        if (sum[item.subject] && sum[item.subject].count > 0) {
                                            subject = item.subject + '(' + sum[item.subject].count2 + ')';
                                            sum[item.subject].count2--;
                                        } else {
                                            subject = item.subject;
                                        }
                                        for (let j = 0; j < imgArr.length; j++) {
                                            ++a;
                                            imgArr[j].ImageUrl += '.png';
                                            this.downImgAjax(imgArr[j].ImageUrl, (img) => {
                                                // 图片下载完回调
                                                --a;
                                                const arr1 = imgArr[j].ImageUrl.split('/');
                                                imageArr.push({
                                                    index: arr1[arr1.length - 1],
                                                    title: subject,
                                                    data: img,
                                                    offerId: item.offerIdStr,
                                                });
                                                if (a === 0) {
                                                    // 请求结束
                                                    this.getZip(imageArr, delId.length); // 开始生成压缩包
                                                }
                                            });
                                        }
                                    }
                                } else {
                                    this.$message.warning('请至少勾选一个状态为“待处理”且还未被删除的产品');
                                }
                            } else {
                                this.loading = false;
                                this.$message.warning('请至少勾选一个状态为“待处理”且还未被删除的产品');
                            }
                        });
                } else {
                    this.$message.warning('请至少勾选一个状态为“待处理”且还未被删除的产品');
                }
            }
        },
        downImgAjax(url, callBack) {
            // 下载图片
            axios(url, {
                method: 'get',
                responseType: 'blob',
            })
                .then((img) => {
                    callBack && callBack(img.data);
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$message.warning('已超时，请重新下载');
                });
        },
        getZip(imageArr, num) {
            // 生成压缩包并下载
            // eslint-disable-next-line new-cap
            const zip = new jszip();
            const zipList = {};
            const year = dayjs().get('year');
            let month = dayjs().get('month') + 1;
            let date = dayjs().get('date');
            if (month < 10) {
                month = '0' + month;
            }
            if (date < 10) {
                date = '0' + date;
            }
            const Schedule = year + '' + month + '' + date;
            for (let i = 0, len = imageArr.length; i < len; i++) {
                const id = imageArr[i].offerId;
                if (!zipList[id]) {
                    zipList[id] = zip.folder(imageArr[i].title);
                }
                zipList[id].file(imageArr[i].index, imageArr[i].data);
            }
            zip.generateAsync({ type: 'blob' })
                .then((res) => {
                    this.loading = false;
                    this.checkedRow = this.showText === 1 ? new Array(this.tableData.length).fill(false) : [];
                    saveAs(res, `共${num}个产品的违规图片${Schedule}.zip`); // 保存成压缩包文件
                })
                .catch((err) => {
                    console.log(err);
                    this.$message.warning('压缩包生成错误!');
                    this.loading = false;
                });
        },
        clearForbiddenWord(row, isAll) {
            // 一键清楚违禁词
            if (isAll) {
                // 全部清除
                this.forbiddenWordJudge(row, isAll);
            } else {
                // 单条清除
                if (row.wordState !== 0) {
                    return;
                }
                const params = {
                    productIdStr: row.offerIdStr + '',
                    pageIndex: 1,
                    pageSize: 10,
                };
                this.loading = true;
                this.$ajax.post('api/tiktok/Product/SearchListV2', params).then((res) => {
                    this.loading = false;
                    if (res.code !== 200 || res.result.list.length === 0) {
                        this.$message.warning('该产品已被删除，不支持修改');
                        return;
                    }
                    this.forbiddenWordJudge(row, isAll);
                });
            }
        },
        forbiddenWordJudge(row, isAll) {
            // 一键清楚违禁词
            let data;
            if (this.showText === 0) {
                // 一键清除违禁词
                if (isAll) {
                    data = {
                        planNo: this.plan.planNo,
                        FwClearType: 0,
                        Action: 0,
                    };
                } else {
                    // 单条清除违禁词
                    data = {
                        selectProductIds: row.offerIdStr,
                        FwClearType: 0,
                        planNo: this.plan.planNo,
                        Action: 0,
                    };
                }

                this.$bus.$emit('openNewTaskProgress', {
                    url: '/api/tiktok/ForbiddenWordPlan/ClearOfferForbiddenWord',
                    taskName: '正在执行中',
                    data,
                    btns: [
                        {
                            name: '取 消',
                            type: '',
                            autoClose: false, // 点击按钮的时候 是否自动关闭进度条
                            callback: this.cancelTask,
                        },
                        {
                            name: '后台运行',
                            type: 'primary',
                            autoClose: true, // 点击按钮的时候 是否自动关闭进度条
                            callback: () => {},
                        },
                    ],
                    callBack: (res) => {
                        if (res.Data.length == 0) {
                            this.$message.success('删除成功');
                            this.getList();
                        } else {
                            this.delFail(res, true);
                        }
                    },
                });
                // this.$refs.taskProgress.show({
                //   url: "app/to/clearfw",
                //   data,
                //   callBack: (res) => {
                //     if (!res.Success) {
                //       this.$message.warning("删除失败");
                //       return;
                //     }
                //     if (res.SuccessCount == res.TotalCount && res.Data.length == 0) {
                //       this.$message.success("删除成功");
                //       this.getList();
                //     } else {
                //       this.delFail(res, true);
                //     }
                //   },
                // });
            }
        },
        delFail(res, isText, isdel) {
            // 删除失败
            let title = isText ? '一键清除含违禁词文字结果' : '一键清除含违禁词图片结果';
            if (isdel) {
                title = '删除产品结果';
            }
            const arr = [];
            for (let i = 0, len = res.Data.length; i < len; i++) {
                const item = res.Data[i];
                arr.push({
                    Title: item.subject || '',
                    Tips: `<p style="color:#e91b00;">${item.msg}</p>`,
                    OfferId: item.productId,
                });
            }
            const tip = `本次共${isdel ? '删除' : '清除'}<em style='color:#FF2E2E'>${
                res.TotalCount
            }</em>个产品，其中成功<em style='color:#FF2E2E'>${
                res.TotalCount - res.failTotalCount
            }</em>个，失败<em style='color:#FF2E2E'>${res.failTotalCount}</em>个`;

            this.$refs.failList.show({
                title,
                tableData: arr,
                topErrorTip: tip,
                showOperation: !isdel && !isText,
                close: () => {
                    this.getList();
                },
            });
        },
        modifyFailed(id) {
            // 清除失败后弹窗中的修改按钮
            const params = {
                planNo: this.plan.planNo,
                offerId: id + '',
                PageIndex: 1,
                PageSize: 10000,
                Type: 0,
            };
            if (this.showText === 1) {
                // 图片检测
                params.Type = 1;
            }
            this.loading = true;
            this.$ajax.post('api/tiktok/ForbiddenWordRecord/Search', params).then((res) => {
                this.loading = false;
                if (res.result.list && res.result.list.length) {
                    if (this.showText === 0) {
                        // 文字检测 相当于手动点击一次手动修改
                        this.textModify(res.Data.Data[0]);
                    } else if (this.showText === 1) {
                        // 图片检测
                        if (res.result.list[0].mainImageFw !== '') {
                            res.result.list[0].mainImageFw = JSON.parse(res.result.list[0].mainImageFw);
                        }
                        if (res.result.list[0].detailImageFw !== '') {
                            res.result.list[0].detailImageFw = JSON.parse(res.result.list[0].detailImageFw);
                        }
                        this.imgModify(res.result.list[0]);
                    }
                    this.gainCategory(res.result.list);
                }
            });
        },
        handleClose(done) {
            this.resetData();
            this.$emit('requestList');
            done();
        },
        openNewTaskProgress(options, callback) {
            this.$refs.newTaskProgress.show(options);
            callback && callback(this.$refs.newTaskProgress);
        },
        // 取消任务
        cancelTask(component) {
            const cancelTip = '是否取消当前任务';
            this.$confirm(cancelTip, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning',
            })
                .then(() => {
                    component.isOpen = false;
                    this.loading = true;
                    this.$ajax
                        .post('api/tiktok/Task/cancel', {
                            taskId: component.progressData.taskId,
                        })
                        .then((res) => {
                            this.loading = false;
                            if (res.code === 200) {
                                component.dialogVisible = false;
                                this.$message.success(this.successTip || '取消成功!');
                                // this.getData();
                                this.$emit('getRecordList');
                            } else {
                                this.$message.warning('取消失败');
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {
                    component.isOpen = true;
                });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        selectable(row) {
            if (this.showText === 0) {
                return row.wordState === 0;
            } else {
                return row.imageState === 0;
            }
        },
        // 全选
        checkAllList() {
            const list = JSON.parse(JSON.stringify(this.checkedRow));
            list.forEach((item, index) => {
                if (this.tableData[index][this.showText === 0 ? 'wordState' : 'imageState'] === 0) {
                    list[index] = this.checkAll;
                }
            });
            this.checkedRow = list;
        },
    },
};
</script>
<style lang="scss">
.res-pop {
    .el-dialog--scroll {
        max-height: fit-content !important;
    }
    .el-dialog__body {
        max-height: fit-content !important;
    }
}
</style>
<style lang="scss" scoped>
.check-report-container {
    .gray {
        color: #a5a5a5;
    }
    .red {
        color: #e91b00;
    }
    .blue {
        color: #0064c1;
    }
    .forbiddenword-input {
        margin-left: 10px;
        // width: 200px;
        &.blue {
            input {
                background: #3a8cee;
                border: 1px solid #3a8cee;
            }
        }
    }
    .tabs-head {
        p {
            width: 100px;
            height: 36px;
            float: left;
            line-height: 36px;
            text-align: center;
            border: 1px solid #ddd;
            position: relative;
            top: 0;
            background: #fff;
            color: #000;
            cursor: pointer;
            & + p {
                border-left: none;
            }
            &.active {
                border-bottom: none;
                color: #0f7bea;
            }
            i {
                width: 25px;
                height: 25px;
                line-height: 25px;
                text-align: center;
                background-color: #fc214a;
                display: inline-block;
                border-radius: 50%;
                color: #fff;
                position: absolute;
                top: -16px;
                right: 3px;
                font-size: 12px;
            }
            &.empty {
                flex: 1;
                border-top: none;
                border-right: none;
                cursor: default;
                text-align: right;
                color: red;
            }
        }
    }
}
.line3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: pre-wrap;
}
</style>
